// Copyright (c) 2021 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
import createReducer from '../../../store/createReducer';
import * as types from './actionTypes';

const initialState = {
  loading: false,
  bookshopCustomer: {
    fullName: '',
    email: '',
    mobile: '',
  },
  requestStatus: {
    status: true,
    messages: [],
  }
};

const issueVoucherReducer = createReducer(initialState, {
  [types.ISSUE_VOUCHER_START_LOADER](state) {
    return {
      ...state,
      loading: true,
    };
  },
  [types.ISSUE_VOUCHER_STOP_LOADER](state) {
    return {
      ...state,
      loading: false,
    };
  },
  [types.ISSUE_VOUCHER_CHANGE_CUSTOMER_FIELDS](state, action) {
    return {
      ...state,
      bookshopCustomer: Object.assign({}, state.bookshopCustomer, {
        [action.field]: action.value,
      }),
      requestStatus: initialState.requestStatus,
    };
  },
  [types.SET_REQUEST_STATUS](state, action) {
    return {
      ...state,
      requestStatus: {
        status: action.status,
        messages: [...state.requestStatus.messages, action.messages]
      }
    };
  },
  [types.BOOKSHOP_CUSTOMER_RESET_FORM](state) {
    return {
      ...state,
      requestStatus: initialState.requestStatus,
      bookshopCustomer: initialState.bookshopCustomer,
    };
  }
});

export default issueVoucherReducer;
